module.exports = __webpack_public_path__ + "media/luxury-2026/stone-detail-0ac2948c.jpg";